import { 
    CREATEINVENTORYITEMCATEGORY, 
    CREATEINVENTORYITEMSTORE, 
    CREATEINVENTORYITEMSUPPLIER, 
    DELETEINVENTORYITEMCATEGORY, 
    DELETEINVENTORYITEMSTORE, 
    DELETEINVENTORYITEMSUPPLIER, 
    GETINVENTORYITEMCATEGORY, 
    GETINVENTORYITEMSTORE, 
    GETINVENTORYITEMSUPPLIER, 
    UPDATEINVENTORYITEMCATEGORY, 
    UPDATEINVENTORYITEMSTORE,
    UPDATEINVENTORYITEMSUPPLIER
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEINVENTORYITEMCATEGORY:
            return {
                ...state,
                itemcategorySaveStatus: action.payload.success,
            }
        case GETINVENTORYITEMCATEGORY:
                return {
                        ...state,
                        itemcategoryList: action.payload.data,
                        }
        case UPDATEINVENTORYITEMCATEGORY:
                return {
                        ...state,
                        itemcategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEINVENTORYITEMCATEGORY:
                 return {
                     ...state,
                     itemcategoryDeleteStatus: action.payload.success,
                        } 
        case CREATEINVENTORYITEMSTORE:
            return {
                ...state,
                itemstoreSaveStatus: action.payload.success,
            }
        case GETINVENTORYITEMSTORE:
                return {
                        ...state,
                        itemstoreList: action.payload.data,
                        }
        case UPDATEINVENTORYITEMSTORE:
                return {
                        ...state,
                        itemstoreUpdateStatus: action.payload.success,
                        }   

        case DELETEINVENTORYITEMSTORE:
                 return {
                     ...state,
                     itemstoreDeleteStatus: action.payload.success,
                        } 
        case CREATEINVENTORYITEMSUPPLIER:
                return {
                        ...state,
                        itemsupplierSaveStatus: action.payload.success,
                        }
        case GETINVENTORYITEMSUPPLIER:
                return {
                        ...state,
                        itemsupplierList: action.payload.data,
                        }
        case UPDATEINVENTORYITEMSUPPLIER:
                return {
                        ...state,
                        itemsupplierUpdateStatus: action.payload.success,
                        }   
                
        case DELETEINVENTORYITEMSUPPLIER:
                return {
                        ...state,
                        itemsupplierDeleteStatus: action.payload.success,
                       } 
                        default:
                            return state
                                  }
                             }